<template>
<main id="main" class="main" role="main">
    <Breadcrumb />
    <div class="section">
        <div class="container">
            <div class="columns">
                <div class="column is-3"></div>
                <ProductList class="column is-9 search-result" v-if="site_data && site_data.result" />
            </div>
        </div>
    </div>
</main>
</template>

<script>
import ProductList from '../blocks/ProductList';
import Breadcrumb from '../blocks/Breadcrumb';
import QueryMixin from '../mixins/QueryMixin';
export default {
    name        :   'SearchPage',
    mixins      :   [ QueryMixin ],
    components  :   {
        ProductList,
        Breadcrumb
    },
    computed    :   {
        site_data()
        {
            return this.$store.state.site_data;
        }
    },
    created()
    {
        if (this.site_data.csrf_expired) {
            this.$router.replace({ query: this.make_query(this.$route.query.page, true)});
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/SearchPage.vue